import _extends from "@babel/runtime-corejs2/helpers/extends";
import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["icon", "shape", "small", "children", "className"];
/* eslint-disable react/prop-types */
import * as React from 'react';
import clsx from 'clsx';
import Svg from '../Svg';
import { Base } from '../Base';
import { SrOnly } from '../Helper';
import ButtonBase from './ButtonBase';
var styles = {
  "root": "IconButton-root_28s6H",
  "wrapper": "IconButton-wrapper_3WVVa",
  "icon": "IconButton-icon_kRNru",
  "sizeDefault": "IconButton-sizeDefault_3bsV6",
  "sizeSmall": "IconButton-sizeSmall_MYQrp"
};
function IconButton(_ref, ref) {
  var _clsx;
  var icon = _ref.icon,
    _ref$shape = _ref.shape,
    shape = _ref$shape === void 0 ? 'compact' : _ref$shape,
    small = _ref.small,
    children = _ref.children,
    className = _ref.className,
    extraProps = _objectWithoutProperties(_ref, _excluded);
  return (
    /*#__PURE__*/
    // $FlowFixMe[cannot-spread-inexact]
    React.createElement(ButtonBase, _extends({
      ref: ref,
      shape: shape,
      small: small,
      className: clsx(styles.root, (_clsx = {}, _defineProperty(_clsx, styles.sizeDefault, !small), _defineProperty(_clsx, styles.sizeSmall, small), _clsx), className)
    }, extraProps), /*#__PURE__*/React.createElement(Base, {
      tagName: "span",
      className: styles.wrapper
    }, /*#__PURE__*/React.createElement(Svg, {
      name: icon,
      className: styles.icon
    }), /*#__PURE__*/React.createElement(SrOnly, null, children)))
  );
}
var Export = /*#__PURE__*/React.forwardRef(IconButton);
Export.displayName = 'IconButton';
export { Export as IconButton };